import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // También puedes registrar el error en un servicio de reporte de errores
        console.error("Error no capturado en el componente de chat:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Si ocurre un error, no renderizamos nada para evitar que el error
            // se propague y rompa la aplicación principal.
            // El chat simplemente desaparecerá o no se montará.
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
